import { useSelector } from 'react-redux';

import { ROLLOUT_CONTINUE_WATCHING } from 'constants/featureFlag';
import { SHOW_CONTINUE_WATCHING_BANNER } from 'constants/triggers';
import { selectInTrimMode } from 'selectors/shareVideo';
import { selectUserIsLogged } from 'selectors/user';
import { selectLoomBrandedPlayer } from 'selectors/videoPlayer';

import { useFlagIsActivated } from './featureFlag';
import { useShouldShowTrigger } from './triggers';

export const useShowContinueWatchingBanner = () => {
  const isLoggedIn = useSelector(selectUserIsLogged);
  const isLoomBranded = useSelector(selectLoomBrandedPlayer);
  const inTrimMode = useSelector(selectInTrimMode);

  const continueWatchingEnabled = useFlagIsActivated({
    flag: ROLLOUT_CONTINUE_WATCHING,
    activationValues: [true],
  });

  const triggerNotComplete = useShouldShowTrigger(
    SHOW_CONTINUE_WATCHING_BANNER
  );

  return (
    !inTrimMode &&
    isLoggedIn &&
    isLoomBranded &&
    triggerNotComplete &&
    continueWatchingEnabled
  );
};
